import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable()
export class TranslationHandlerService implements MissingTranslationHandler {
  //please note a bug when not using the default lang
  //if not on the default lang the UI will show blank even with this handler
  //which is why in the intial config we set whatever the userLang is to also be the default lang
  //so the missing translation handler will display what shows below instead of blank
  //https://github.com/ocombe/ng2-translate/issues/87
  handle(params: MissingTranslationHandlerParams) {
    return '[' + params.key + ']';
  }
}
